import { useCallback, useState } from 'react';
import axios from 'axios';
import { useShowErrors } from '../../../hooks/useShowErrors';
import { LOGIN_URL } from '../../../constants';
import { ILogin } from '../../../interfaces/user';
import { IUser } from '../interfaces';

export const useAxiosEnterPassword = () => {
  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState<IUser | null>(null);
  const [err, setErr] = useState<any>(null);

  const makeRequest = useCallback((data: ILogin) => {
    setLoading(true);
    axios
      .post(LOGIN_URL, data)
      .then(res => setRes(res.data))
      .catch(err => {
        if (err) setErr(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useShowErrors([err]);

  return { makeRequest, loading, res };
};
